import * as React from 'react'

interface ProgressBarProps {
	percent: number
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percent }) => (
	<div className="flex flex-col items-center pb-10 bg-white pt-7 px-7 gap-7 rounded-xl shadow-container">
		<div className="text-xs font-bold tracking-widest uppercase text-brand-gray-400">Completed Information</div>
		{/* Empty Bar */}
		<div
			data-showzero={percent < 11 ? '' : '0%'}
			data-showfull={percent > 82 ? '' : '100%'}
			className="before:absolute before:content-[attr(data-showzero)] before:top-3 font-medium text-xs text-brand-gray-200 after:content-[attr(data-showfull)] after:right-0 after:absolute after:top-3 relative rounded bg-brand-gray-100 w-full h-1.5"
		>
			{/* Filler */}
			<div
				style={{ width: `${percent}%` }}
				data-percent={`${percent}%`}
				className="absolute top-0 h-full transition-all rounded before:absolute bg-brand-primary-md after:absolute after:-right-3.5 after:top-3 font-semibold text-brand-primary-md text-center text-xs after:content-[attr(data-percent)]"
			/>
		</div>
	</div>
)

export default ProgressBar
